import React from "react";
import track from "react-tracking";

import { Flex } from "@chakra-ui/react";

import HomeView from "components/HomeView";
import Onboarding from "components/HomeView/Onboarding";
import { usePageNavigationHeader } from "contexts/LayoutContext/LayoutContext";
import { Loader } from "elements";
import useFetchClaimsEnquiries from "hooks/api/claims/useFetchClaimsEnquiries";
import useFetchJourneys from "hooks/api/journeys/useFetchJourneys/useFetchJourneys";
import useFetchLoungePasses from "hooks/api/userProfiles/useFetchLoungePasses/useFetchLoungePasses";
import useFetchMyProfile from "hooks/api/userProfiles/useFetchMyProfile/useFetchMyProfile";
import useProtectedPage from "hooks/routing/useProtectedPage";
import { Journey } from "models/Journey";
import { LoungePass } from "models/LoungePass";
import { UserProfile } from "models/UserProfile";
import { usePageTracking } from "utils/tracking";

const HomePage: React.FC = () => {
  usePageTracking();
  useProtectedPage();
  usePageNavigationHeader(null);

  const { isLoading: isJourneysLoading, data: journeysData } = useFetchJourneys();
  const { isLoading: isLoungePassesLoading, data: loungePassesData } = useFetchLoungePasses();
  const { data: userProfile, isLoading: isUserProfileLoading } = useFetchMyProfile();

  const { data: claimEnquiriesData, isLoading: isClaimEnquiriesLoading } = useFetchClaimsEnquiries();

  const claimEnquiries = claimEnquiriesData || [];

  const isLoading = isUserProfileLoading || isJourneysLoading || isLoungePassesLoading || isClaimEnquiriesLoading;
  const journeys = (journeysData || []) as Journey[];
  const loungePasses = (loungePassesData || []) as LoungePass[];

  if (isLoading) {
    return (
      <Flex alignItems="center" justifyContent="center">
        <Loader dataTestId="loader" />
      </Flex>
    );
  }

  return (
    <>
      <Onboarding />
      <HomeView
        userProfile={userProfile as UserProfile}
        journeys={journeys}
        loungePasses={loungePasses}
        claims={claimEnquiries}
      />
    </>
  );
};

export default track({ page_type: "Home" })(HomePage);
